import { Component, Inject, Optional } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { AppButton } from '../../../../shared/models/button.model';
import { ButtonComponent } from '../../../../shared/components/ui/buttons/button/button.component';
import { RoleplayFeedbackApiService } from '../../../../services/roleplay-feedback/roleplay-feedback-api.service';
import { TextareaComponent } from '../../form-controls';
import { CommonModule } from '@angular/common';
import { AppFormControlField, FieldOption } from '../../../models/form-controls.model';

export interface UserFeedbackDialogData {
  chat_session_id?: number;
}

@Component({
  selector: 'app-user-feedback',
  standalone: true,
  imports: [
    MatDialogModule,
    ReactiveFormsModule,
    ButtonComponent,
    TextareaComponent,
    CommonModule
  ],
  templateUrl: './user-feedback.component.html',
  styleUrl: './user-feedback.component.scss'
})
export class UserFeedbackComponent {
  feedbackForm: FormGroup;

  skipButton: AppButton = {
    extraClass: 'btn-white-bdr',
    label: 'Skip',
    type: 'normal'
  };

  submitButton: AppButton = {
    label: 'Submit Feedback',
    type: 'normal'
  };

  experienceOptions: FieldOption[] = [
    { value: 1, label: 'Very Poor' },
    { value: 2, label: 'Poor' },
    { value: 3, label: 'Bad' },
    { value: 4, label: 'Average' },
    { value: 5, label: 'Good' },
    { value: 6, label: 'Excellent' }
  ];

  fields: Record<string, AppFormControlField> = {
    rating: { label: 'Rating', options: this.experienceOptions, required: true },
    comment: {
      label: 'Additional Comments',
      extraClass: 'custom-textarea',
      placeholder: 'Share your thoughts about the roleplay session...',
      rows: 4
    }
  };

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<UserFeedbackComponent>,
    private roleplayFeedbackApiService: RoleplayFeedbackApiService,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: UserFeedbackDialogData
  ) {
    this.feedbackForm = this.fb.group({
      rating: [null, Validators.required],
      comment: ['']
    });
  }

  onSubmit() {
    if (this.feedbackForm.valid) {
      const ratingValue = this.feedbackForm.get('rating').value;
      const ratingOption = this.experienceOptions.find(o => o.value === ratingValue);

      const payload = {
        chat_session_id: this.dialogData?.chat_session_id || 0,
        rating: ratingOption?.label || '',
        comment: this.feedbackForm.get('comment').value || '',
        business_unit_code: sessionStorage.getItem('businessUnitCode') || '',
        given_by: Number(sessionStorage.getItem('userId')),
      };

      this.roleplayFeedbackApiService.createFeedback(payload).subscribe({
        next: (response) => {
          console.log('Feedback submitted successfully:', response);
          this.dialogRef.close(true);
        },
        error: (error) => {
          console.error('Error submitting feedback:', error);
        }
      });
    }
  }

  onSkipClick() {
    this.dialogRef.close();
  }

  onClickExperience(option: FieldOption) {
    this.feedbackForm.get('rating').setValue(option.value);
  }

}